import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Hide = props => {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10 4.5C6.45865 4.5 3.40489 6.75155 2 10C3.40489 13.2485 6.45865 15.5 10 15.5C13.5413 15.5 16.5951 13.2485 18 10C16.5951 6.75155 13.5413 4.5 10 4.5Z" stroke="currentColor" strokeWidth="1.25" strokeMiterlimit="10" strokeLinejoin="round" />;
    t1 = <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M15.9359 4.06415L3.93591 16.0641" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Hide;